module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDQiIGhlaWdodD0iOTIiIHZpZXdCb3g9IjAgMCAxMDQgOTIiPjxnIG9wYWNpdHk9Ii45Ij48Y2lyY2xlIGN4PSI3LjUiIGN5PSItNC41IiByPSI5NS41IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDg0RkYiIHN0cm9rZS1vcGFjaXR5PSIuMzA3IiBvcGFjaXR5PSIuNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLjI4NikiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/service-bg-6.svg
// module id = 88
// module chunks = 35783957827783 79611799117203 85929988179075 182101406987512